// @core/api/endpoints/calendar/create_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEventRequest,
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create event
 * Creates a new calendar event with optional attendees, location, conference, and reminders. Supports all-day, timed, and multi-day events.
 */
export async function CreateEvent(
  calendar_id: string,
  data: CreateEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/events`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
